// RangeSelector.jsx
import React from "react";
import { IonRange, IonButton } from "@ionic/react";
import HelpButton from "./HelpButton"; // Assuming HelpButton is in the same directory
import "./RangeSelector.css";

interface RangeSelectorProps {
  title: string;
  min: number;
  max: number;
  step: number;
  value: number;
  unit?: string;
  helpId?: string;
  labels?: {
    [key: number]: { label: string; color: string; "bg-color": string };
  };
  onValueChange: (value: number) => void;
  isStopLoss?: boolean;
  isEnabled?: boolean;
  toggleEnabled?: () => void;
  badgeLevels?: {
    [key: number]: { label: string; color: string; "bg-color": string };
  };
  badgeLevel?: number;
}

const RangeSelector: React.FC<RangeSelectorProps> = ({
  title,
  min,
  max,
  step,
  value,
  labels,
  onValueChange,
  unit = "",
  isStopLoss = false,
  helpId,
  isEnabled = true,
  toggleEnabled,
  badgeLevels,
  badgeLevel
}) => {
  const rangeClass = isStopLoss ? "range-stop-loss" : "";
  const valueHighlightClass = labels?.[value]?.["bg-color"] ? "primary-70" : "";
  return (
    <div className="range-selector-container bg-primary-90 rounded-xl mt-4 px-4">
      <div className="grid grid-cols-3 items-center pt-4 gap-4">
        <p className="text-sm text-white col-span-2">{title}</p>
        <div className="flex justify-end items-center col-span-1 -m-3">
          {toggleEnabled && (
            <IonButton
              size="small"
              color="primary"
              onClick={toggleEnabled}
              fill="solid"
              className="ml-2"
            >
              {isEnabled ? "Disable" : "Enable"}
            </IonButton>
          )}
          {badgeLevels && (
            <div
              className={`py-2 px-4 mr-3 rounded text-xs text-center text-primary-90 font-semibold ${
                badgeLevels?.[badgeLevel || 0]?.["bg-color"]
              } ${badgeLevels?.[badgeLevel || 0]?.color}`}
            >
              {badgeLevels?.[badgeLevel || 0]?.label}
            </div>
          )}
          <HelpButton id={helpId} />
        </div>
      </div>
      <div className="flex items-center">
        <IonRange
          className={`${rangeClass} my-4`}
          snaps={false}
          min={min}
          max={max}
          step={step}
          value={value}
          onIonChange={e => onValueChange(e.detail.value as number)}
          disabled={!isEnabled}
        ></IonRange>
        <div
          className={`pl-2 pr-4 text-xs text-white font-bold ${labels?.[value]?.["bg-color"]} ${labels?.[value]?.color} ${valueHighlightClass} col-span-1 text-center`}
        >
          {`${value}${unit}`} {labels?.[value]?.label}
        </div>
      </div>
    </div>
  );
};

export default RangeSelector;
